<template>
  <div class="comp-main">
    <FilterTop
      :active_parent_key.sync="active_parent_key"
      :listParent="listParent"
      @clear="activeListClear"
    />
    <div
      class="comp-bottom"
      v-for="(itemSt, indexSt) in listParent"
      :key="indexSt"
      v-show="itemSt.key === active_parent_key"
    >
      <FilterGroup
        v-for="(itemNd, indexNd) in itemSt.list"
        :key="indexNd"
        :ref="`refFilterGroup${indexSt}-${indexNd}`"
        :init_filter_data="init_filter_data"
        :isShowTitle="itemSt.list.length > 1"
        :itemDataFilter="itemNd"
        :listActiveFilter="listActiveFilter"
        :click_key="click_key"
        :search_data="search_data"
        @success="listActiveChange"
      />
    </div>
  </div>
</template>

<script>
import FilterTop from './filter-top'
import FilterGroup from './filter-group'
export default {
  props: {
    init_filter_data: {
      type: Object,
      required: true
    },
    search_data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {
    FilterTop,
    FilterGroup
  },
  data() {
    return {
      active_parent_key: this.init_filter_data.active_parent_key,
      click_key: '',
      listParent: []
    }
  },
  computed: {
    // 选中筛选列表
    listActiveFilter() {
      let result = []
      this.listParent.forEach((itemSt) => {
        itemSt.list.forEach((itemNd) => {
          let addArr = this.$util.deepCopy(itemNd.active)
          result = [...result, ...addArr]
        })
      })
      return result
    }
  },
  watch: {
    search_data() {
      this.activeListClear('all')
    },
    // 选中筛选列表
    listActiveFilter: {
      handler(newVal, oldVal) {
        let isChange = JSON.stringify(newVal) !== JSON.stringify(oldVal)
        if (isChange) {
          let list = newVal.sort((a, b) => a.sort_time - b.sort_time)
          let listType = list.map((item) => item.field_type)
          let len = listType.length
          let type = len ? listType[len - 1] : this.init_filter_data.active_search_type
          let result = {
            type,
            list: newVal
          }
          this.$emit('success', result)
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.getListParent()
  },
  methods: {
    // 获取父级列表
    async getListParent() {
      await this.$api({
        method: 'post',
        url: this.init_filter_data.api_url_parent
      }).then((res) => {
        this.listParent = res.data.list
      })
    },
    // 列表选中更新
    listActiveChange(data) {
      this.click_key = data.key
      this.listParent.forEach((itemSt) => {
        itemSt.list.forEach((itemNd) => {
          if (JSON.stringify(itemNd.key) === JSON.stringify(data.key)) {
            itemNd.active = data.active
          }
        })
      })
    },
    // 选中列表清空
    activeListClear(val) {
      this.click_key = ''
      if (val === 'all') {
        this.listParent.forEach((itemSt) => {
          itemSt.list.forEach((itemNd) => {
            itemNd.active = []
          })
        })
      } else {
        this.listParent[val].list.forEach((itemNd) => {
          itemNd.active = []
        })
      }
    },
    // 更新筛选组数据
    updateFilterGroupData() {
      this.listParent.forEach((itemSt, indexSt) => {
        itemSt.list.forEach((itemNd, indexNd) => {
          let refName = `refFilterGroup${indexSt}-${indexNd}`
          this.$refs[refName][0].searchListData()
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.comp-main {
  position: relative;
  top: 0;
  bottom: 0;
  width: 146px;
  margin-right: 10px;
  border: @border;
  .comp-bottom {
    position: absolute;
    left: 0;
    right: 0;
    top: 38px;
    bottom: 0;
    display: flex;
    flex-direction: column;
    border-top: @border;
  }
}
</style>
